import {Localisation} from "../localisation/localisation";
import {CSSProperties} from "react";
import {Dialog} from "@components/interface/Dialog";
import {THEME} from "@components/core/theme";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    callstack: {
        ...THEME.text,
        fontSize: "small",
        marginBottom: 12,
        marginTop: 12,
        overflow: "scroll"
    }
}

interface IErrorFallback {
    error: Error
    resetError: () => void
}
export function ErrorFallback({error, resetError}: IErrorFallback) {
    const handleReload = () => {
        resetError();
        window.location.reload();
    };

    return (
        <Dialog title="ErrorTitle">
            <span style={styles.text}>{error.message}</span>
            <div style={styles.callstack}>
                <span>{error.stack}</span>
            </div>
            <div style={styles.buttons}>
                <button onClick={handleReload} style={styles.button}>
                    {Localisation.GetText("ErrorButtonReload")}
                </button>
            </div>
        </Dialog>
    );
}